var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getSurvayData, saveSurvayData } from "./api";
import { call, put, takeLatest, all, select } from 'redux-saga/effects';
import { initSurvaySuccess, initSurvay, slidePage, savePage, changeQuestion, goBackOnePage } from "./actions";
// import { logIn } from '../../../app-ducks/l'
import { blockUi, unBlockUi } from './../../../containers/BlockUi/ducks/actions';
export function onInitSurvay() {
    var data, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(blockUi())];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, 6, 8]);
                return [4 /*yield*/, call(getSurvayData)];
            case 3:
                data = _a.sent();
                return [4 /*yield*/, put(initSurvaySuccess(data))];
            case 4:
                _a.sent();
                return [3 /*break*/, 8];
            case 5:
                e_1 = _a.sent();
                if (e_1.response.status === 401) {
                    localStorage.removeItem('token');
                }
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(unBlockUi())];
            case 7:
                _a.sent();
                return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}
export function onSavePage(params) {
    var survay, questions, reqBody, _i, questions_1, question, questionId_1, questionIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(blockUi())];
            case 1:
                _a.sent();
                return [4 /*yield*/, select()];
            case 2:
                survay = (_a.sent()).survay;
                questions = survay.survays.slice();
                _a.label = 3;
            case 3:
                _a.trys.push([3, 7, 10, 12]);
                reqBody = { pageNum: survay.page, questions: [] };
                for (_i = 0, questions_1 = questions; _i < questions_1.length; _i++) {
                    question = questions_1[_i];
                    if (question.withError) {
                        throw new Error();
                    }
                    if (question.isRequired && !question.answer && question.page === survay.page) {
                        throw question.id;
                    }
                    if (question.answer !== null) {
                        reqBody.questions.push(__assign({ surveyQuestionId: question.surveyQuestionId, answer: String(question.answer) }, (question.employerId ? { employerId: question.employerId } : {})));
                    }
                }
                if (!(reqBody.questions.length > 0)) return [3 /*break*/, 5];
                return [4 /*yield*/, call(saveSurvayData(reqBody))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, put(slidePage(params.payload + 1))];
            case 6:
                _a.sent();
                return [3 /*break*/, 12];
            case 7:
                questionId_1 = _a.sent();
                questionIndex = questions.findIndex(function (q) { return q.id === questionId_1; });
                if (!(questionIndex >= 0)) return [3 /*break*/, 9];
                questions[questionIndex] = __assign(__assign({}, questions[questionIndex]), { withError: true });
                return [4 /*yield*/, put(initSurvaySuccess({ pageNum: survay.page, questions: questions }))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, put(unBlockUi())];
            case 11:
                _a.sent();
                return [7 /*endfinally*/];
            case 12: return [2 /*return*/];
        }
    });
}
export function onGoBackOnePage() {
    var survay, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(blockUi())];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, 6, 8]);
                return [4 /*yield*/, select()];
            case 3:
                survay = (_a.sent()).survay;
                return [4 /*yield*/, put(slidePage(survay.page - 1))];
            case 4:
                _a.sent();
                return [3 /*break*/, 8];
            case 5:
                e_2 = _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(unBlockUi())];
            case 7:
                _a.sent();
                return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}
export function onChangeQuestion(params) {
    var question, survay, questions, firstQOfPageThree, questionIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                question = params.payload;
                return [4 /*yield*/, select()];
            case 1:
                survay = (_a.sent()).survay;
                questions = (question.withError || question.toChange) ? survay.survays.slice() : survay.survays;
                if (question.toChange !== undefined) {
                    question.withError = false;
                }
                if (survay.page === 3) {
                    firstQOfPageThree = questions.find(function (question) { return question.id === 11; });
                    if (firstQOfPageThree && firstQOfPageThree.answer && ((firstQOfPageThree.answer === '48' && question.id === 11 && question.answer !== '48') || (firstQOfPageThree.answer !== '48' && question.id === 11 && question.answer === '48'))) {
                        questions = questions.map(function (question) {
                            if (question.page === 3 && question.id !== 11 && question.id !== 12) {
                                question.answer = null;
                            }
                            return question;
                        });
                    }
                }
                questionIndex = survay.survays.findIndex(function (q) { return q.surveyQuestionId === question.surveyQuestionId; });
                if (!(questionIndex >= 0)) return [3 /*break*/, 3];
                questions[questionIndex] = question;
                return [4 /*yield*/, put(initSurvaySuccess({ pageNum: survay.page, questions: questions }))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
export default function survaySagas() {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = all;
                return [4 /*yield*/, takeLatest(initSurvay, onInitSurvay)];
            case 1:
                _b = [
                    _c.sent()
                ];
                return [4 /*yield*/, takeLatest(savePage, onSavePage)];
            case 2:
                _b = _b.concat([
                    _c.sent()
                ]);
                return [4 /*yield*/, takeLatest(changeQuestion, onChangeQuestion)];
            case 3:
                _b = _b.concat([
                    _c.sent()
                ]);
                return [4 /*yield*/, takeLatest(goBackOnePage, onGoBackOnePage)];
            case 4: return [4 /*yield*/, _a.apply(void 0, [_b.concat([
                        _c.sent()
                    ])])];
            case 5:
                _c.sent();
                return [2 /*return*/];
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/pages/Survay/ducks/sagas.ts
// module id = 694
// module chunks = 0